import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, forwardRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { Modifier } from '@popperjs/core';
import { DropdownInputComponent } from '../../../../views/shared/components/form-components/dropdown-input/dropdown-input.component';
import { DropdownItemHighlightedPipe } from '../../../../views/shared/components/form-components/dropdown-input/dropdown-item-highlighted.pipe';
import { minWidth } from '../../../../utils/popper-modifiers/min-width.modifier';
import { DropdownOptionIdPipe } from '../../../form-components/descriptive-dropdown-input/dropdown-option-id.pipe';

@Component({
  selector: 'app-table-header-select-input',
  standalone: true,
  imports: [CommonModule, DropdownItemHighlightedPipe, DropdownOptionIdPipe],
  templateUrl: '../../../../views/shared/components/form-components/dropdown-input/dropdown-input.component.html',
  styleUrls: ['../table-column-inputs.scss', './table-header-select-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TableHeaderSelectInputComponent),
      multi: true
    }
  ],
  changeDetection: ChangeDetectionStrategy.Default
})
export class TableHeaderSelectInputComponent extends DropdownInputComponent {
  @Input() placeholder: string = $localize`Select`;

  protected override popperWidthModifiers(): Modifier<any, any>[] {
    return [minWidth];
  }
}
